module.exports = __webpack_public_path__ + "static/verified-e71ce27ee9be884f6ad5679b736024f3.png";